import { type UserDataType } from '@app-types/UserDataType'
import useFontSizes from '@hooks/useFontSizes'
import { ChangeEvent } from 'react'
import { FaMinus, FaPlus } from 'react-icons/fa6'
import DuaSample from './DuaSample'
import SegmentedToggle from './SegmentedToggle'

export type DuaSettingsProps = {
  userData: UserDataType
  handleInputChange: (_event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
}

export default function DuaSettings({
  userData,
  handleInputChange,
}: DuaSettingsProps): React.ReactNode {
  const { duaArabFontSize, duaMealFontSize, setFontSize } = useFontSizes()
  console.log(duaArabFontSize, duaMealFontSize, 'duaArabFontSize')
  return (
    <>
      <DuaSample />
      <div className="flex justify-between items-center my-4 py-3 border-b border-main space-x-4">
        <strong className="text-main">Dua Arapça Boyutu</strong>
        <div className="flex bg-surface-subtle border border-main rounded-xl p-1 gap-1">
          <button
            className="w-12 h-10 flex flex-center rounded-lg text-muted hover:bg-main hover:text-main hover:shadow-sm transition-all"
            onClick={() => {
              setFontSize(duaArabFontSize - 1, 'duaArabFontSize')
            }}
            aria-label="Dua Arapça boyutunu küçült"
          >
            <FaMinus />
          </button>
          <div className="w-[2px] bg-main my-2 mx-1"></div>
          <button
            className="w-12 h-10 flex flex-center rounded-lg text-muted hover:bg-main hover:text-main hover:shadow-sm transition-all"
            onClick={() => {
              setFontSize(duaArabFontSize + 1, 'duaArabFontSize')
            }}
            aria-label="Dua Arapça boyutunu büyüt"
          >
            <FaPlus />
          </button>
        </div>
      </div>
      <div className="flex justify-between items-center my-4 py-3 border-b border-main space-x-4">
        <strong className="text-main">Dua Meal Boyutu</strong>
        <div className="flex bg-surface-subtle border border-main rounded-xl p-1 gap-1">
          <button
            className="w-12 h-10 flex flex-center rounded-lg text-muted hover:bg-main hover:text-main hover:shadow-sm transition-all"
            onClick={() => {
              setFontSize(duaMealFontSize - 1, 'duaMealFontSize')
            }}
            aria-label="Dua Meal boyutunu küçült"
          >
            <FaMinus />
          </button>
          <div className="w-[2px] bg-main my-2 mx-1"></div>
          <button
            className="w-12 h-10 flex flex-center rounded-lg text-muted hover:bg-main hover:text-main hover:shadow-sm transition-all"
            onClick={() => {
              setFontSize(duaMealFontSize + 1, 'duaMealFontSize')
            }}
            aria-label="Dua Meal boyutunu büyüt"
          >
            <FaPlus />
          </button>
        </div>
      </div>

      <div className="flex justify-between items-center my-4 py-3 border-b border-main">
        <label htmlFor="duaArabicVisibility" className="font-bold text-main">
          Dua Arapça
        </label>
        <SegmentedToggle
          value={userData.duaArabicVisibility === 'show'}
          onChange={(val) => 
            handleInputChange({ target: { name: 'duaArabicVisibility', value: val ? 'show' : 'hide' } } as React.ChangeEvent<any>)
          }
          trueLabel="Göster"
          falseLabel="Gizle"
        />
      </div>
      <div className="flex justify-between items-center my-4 py-3 border-b border-main">
        <label htmlFor="duaMealVisibility" className="font-bold text-main">
          Dua Meali
        </label>
        <SegmentedToggle
          value={userData.duaMealVisibility === 'show'}
          onChange={(val) => 
            handleInputChange({ target: { name: 'duaMealVisibility', value: val ? 'show' : 'hide' } } as React.ChangeEvent<any>)
          }
          trueLabel="Göster"
          falseLabel="Gizle"
        />
      </div>
      <div className="flex justify-between items-center my-4 py-3 border-b border-main">
        <label htmlFor="duaLatinVisibility" className="font-bold text-main">
          Dua Latin
        </label>
        <SegmentedToggle
          value={userData.duaLatinVisibility === 'show'}
          onChange={(val) => 
            handleInputChange({ target: { name: 'duaLatinVisibility', value: val ? 'show' : 'hide' } } as React.ChangeEvent<any>)
          }
          trueLabel="Göster"
          falseLabel="Gizle"
        />
      </div>
      <p className="text-xs">
        Latin harfleri ile okunuş şimdilik sadece bazı dualarda mevcuttur.
      </p>
    </>
  )
}
